import { FormKey } from '../../enums/formKey';
import { StepKey } from '../../enums/stepKey';
import { ApplianceFormData } from '../../store/store.types';

export const getFormRegionOrStateCode = (formData: ApplianceFormData): string | undefined => {
  const regionOrStateCode = formData[StepKey.PERSONAL_DETAILS]?.[FormKey.STATE_CODE];
  return typeof regionOrStateCode === 'string' ? regionOrStateCode : undefined;
};
